import { createContext, useContext } from 'react'
import pino from 'pino'

export const log = pino()
export const LogContext = createContext(log)
export const useLogger = () => useContext(LogContext)
